module.exports = __webpack_public_path__ + "static/media/After-You.394c927b.png";